
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spare-parts/[...slug]",
      function () {
        return require("private-next-pages/spare-parts/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spare-parts/[...slug]"])
      });
    }
  